import React, { useEffect } from 'react'
import styled from 'styled-components'
import Button from '../shared/Button'
import { useDispatch, useSelector } from 'react-redux'
import { showModal } from '../../features/modal/modalSlice'
import { logoutUser } from '../../features/auth/authSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import { useScrollLock } from '../../hooks/useScrollLock'
import Btn from '../shared/button/Btn'

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: 200px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        justify-content: space-between;
        p{
            font-size: 15px;
            font-weight: var(--font-weight-lg);
            text-align: center;
            color: ${({ theme }) => theme.mainTextColor};
            line-height: 25px;
        }

    }
`
const LoadPermissionErrorModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
    
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={() => dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
            <p>Zorunlu alanlardan doldurulmayan alan bulunmaktadır. Adımlarda eksikler sayıyla gösterilmiştir. Zorunlu Alanları Tamamlayınız.</p>
            
            <div className="btn">
                <Btn handleClick={() => dispatch(showModal(null))} color='#E85446' bgColor='transparent' padding='10px' width="150px">Kapat</Btn>
            </div>
        </div>
    </Container>
  )
}

export default LoadPermissionErrorModal